import { render, staticRenderFns } from "./OrganizationsByProductSectionDialog.vue?vue&type=template&id=54760b01&"
import script from "./OrganizationsByProductSectionDialog.vue?vue&type=script&lang=js&"
export * from "./OrganizationsByProductSectionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports